export default {
    title: 'Kostenstellen',

    name: 'Bezeichnung',
    number: 'Nummer',

    addCostCenter: 'Neue Kostenstelle',
    addNewCostCenter: 'Neue Kostenstelle hinzufügen',
    editCostCenter: 'Kostenstelle bearbeiten',
    saveCostCenter: 'Kostenstelle speichern',
    selectCostCenter: 'Kostenstelle auswählen',
    deleteCostCenter: 'Kostenstelle löschen',
    deleteCostCenterText: 'Möchten Sie diese Kostenstelle wirklich löschen?',
    deleteCostCenterNameText: 'Möchten Sie die Kostenstelle "{name}" wirklich löschen?',

    successfullySaved: 'Kostenstelle wurde erfolgreich gespeichert.',
    successfullyDeleted: 'Kostenstelle wurde erfolgreich gelöscht.',
    couldNotBeSaved: 'Kostenstelle konnte nicht gespeichert werden.',
    couldNotBeDeleted: 'Kostenstelle konnte nicht gelöscht werden.'
}